//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'FullPageLoading',

  data() {
    return {
      loading: false,
    };
  },

  methods: {
    start() {
      this.loading = true;
    },
    finish() {
      this.loading = false;
    },
  },
};
